<template>
  <div class="NormalWithWords relative" style="position: relative;" @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave">
    <img v-if="photo" :src="photo" :alt="alt" class="photo" @click="open" />
    <transition-group name="move">
      <template v-if="showDefaultWords && !isShowWords">
        <div class="absolute" style="position: absolute;" key="default" :class="defaultPosition">
          <slot></slot>
        </div>
      </template>
      <!-- 判断是否显示文字 -->
      <template v-if="isShowWords">
        <!-- 动态显隐的设置 -->
        <div key="shade" class="absolute" style="position: absolute; width: 100%;height: 100%;" :class="[
          shade === 'always' && 'shade-bg',
          shade === 'hover' && hover && 'shade-bg',
          position,
        ]" @click="open">
          <slot name="words"></slot>
        </div>
      </template>
    </transition-group>
  </div>
</template>

<script>
// import Sapar from "@/components/Sapar.vue"
export default {
  name: "NormalWithWords",
  props: {
    photo: String, // 图片
    alt: String, // 图片加载不超过时的文字
    id: Number,
    showDefaultWords: {
      type: Boolean,
      default: false,
    },
    defaultPosition: {
      type: String,
      default: "top-left",
    },
    needJump: {
      // 是否需要转跳
      type: Boolean,
      default: true,
    },
    showWords: {
      // 是否展示文字
      type: Boolean,
      default: true,
    },
    shade: {
      // 背景是否展示
      type: String,
      default: "always",
    },
    position: { type: String, default: "top-left" }, // 蒙层显示的位置 top-left top-right middle bottom
  },
  components: {
    // Sapar
  },
  computed: {
    // 计算何时显示蒙层
    isShowWords() {
      return (this.shade !== "hover" || this.hover) && this.showWords;
    },
  },
  data() {
    return {
      hover: false,
      dialogTableVisible: false,
      defautlurl: 'https://external.333f.com/333f-2021-api/public/storage/'
    };
  },
  methods: {
    // 监听鼠标进入的事件
    handleMouseEnter() {
      this.hover = true;
    },
    // 监听鼠标移出的事件
    handleMouseLeave() {
      this.hover = false;
    },
    open() {
      if (this.needJump) {
        this.$emit('click')
      }
      else {
        this.$emit('setIndex', this.id)
      }
      // this.$router.push('/industryPavilionCase/' + this.id)
    },
  },
};
</script>

<style lang="less" scoped>
.NormalWithWords,
.photo {
  width: 100%;
  height: auto;
  cursor: pointer;
  overflow: hidden;
  display: block;
}

.photo {
  height: 100%;
  object-fit: cover;
}

.shade-bg {
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
}

.top-left {
  top: 0;
  left: 0;
}

.top-right {
  top: 0;
  left: 0;
}

.middle {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.bottom {
  bottom: 0;
  left: 0;
}

.move-enter-active,
.move-leave-active {
  transition: all 1s;
}

.move-enter,
.move-leave-active {
  opacity: 0;
}

.move-enter,
.move-leave-to {
  transform: translateX(-100%);

  &.middle {
    transform: translateX(-100%) translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NormalWithWords.vue